import { gpt5 } from "../assets";
import Button from "./Button";
import Section from "./Section";
import { BackgroundCircles } from "./design/Hero";
import { useRef } from "react";
import CompanyLogos from "./CompanyLogos";
import useIsTabletOrLarger from "./useIsTabletOrLarger";
const Hero = () => {
  const parallaxRef = useRef(null);

  const isTabletOrLarger = useIsTabletOrLarger();

  return (
    <Section
      className="-mt-[5.25rem] pt-[9rem]"
      crosses
      crossesOffset="lg:translate-y-[5.25rem]"
      customPaddings
      id="hero"
    >
      <div
        className="container relative grid grid-cols-1 lg:grid-cols-2 xl:mt-16 xl:translate-x-8"
        ref={parallaxRef}
      >
        <div className="relative z-1 mx-auto mb-[3.875rem] max-w-[62rem] text-center md:mb-20 lg:mb-[6.25rem] xl:text-start">
          <h1 className="h1 mb-6">
            Elevate Your Digital Presence with <br />
            <span className="text-purple-600">Bafar Labs</span>
          </h1>

          <p className="f-c body-1 mb-6 max-w-3xl text-slate-200 lg:mb-8">
            At Bafar Labs, we design high-performance websites, custom software
            solutions, and innovative AI-driven tools to empower businesses and
            unlock growth opportunities.
          </p>
          <Button
            href="https://wa.me/+919539642647"
            target="_blank"
            rel="noopener noreferrer"
            className="text-base"
            white
          >
            Connect with us
          </Button>
        </div>

        <div className="relative mx-auto max-w-[23rem] sm:max-w-[35rem] md:max-w-6xl xl:mb-24">
          <img
            src={gpt5}
            className="md:-translate-y-8"
            width={632}
            height={600}
            alt="Hero Image"
          />
        </div>
        {isTabletOrLarger && <BackgroundCircles />}
      </div>
      <CompanyLogos className="container relative z-10 mt-20 hidden lg:block" />
    </Section>
  );
};

export default Hero;
